import { tv } from 'tailwind-variants'

import { typography } from '@gto/ui/typography'

export const fieldVariants = tv({
  slots: {
    root: 'group/field flex flex-col gap-0.5',
    label: [
      typography['input/label'],
      'flex cursor-pointer items-center gap-1 min-h-4 px-2 transition-colors',

      // `:where()` gives the hover tint the lowest specificity, so the focus, open, invalid and
      // disabled tints below win over it.
      'group-has-[:where(input:hover)]/field:text-text-primary',
      'group-has-[:focus-visible]/field:text-primary-main',
      'group-has-[.ui-popup-open]/field:text-primary-main',
      'group-has-[:invalid]/field:text-error-main',
      'group-data-[invalid]/field:text-error-main group-has-[.ui-invalid]/field:text-error-main',
      'group-has-[:disabled]/field:text-text-disabled',
    ],
    error: 'px-2 text-error-main text-[10px] leading-[166%] tracking-[0.4px]',
  },
})
